var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('CAP0530_co',{key:_vm.componentKey,on:{"reload":_vm.forceReload}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }